import React from 'react';

import { clsx } from 'clsx';

import FadeIn from 'src/components/elements/FadeIn';
import { CompletedProjectsData } from 'src/components/pages/PartnersPage/constants';

import styles from './CompletedProjects.scss';

const CompletedProjects = () => (
  <section data-locator="partnersCompletedProjects" className={styles.blockContainer}>
    <FadeIn delay={0.2}>
      <p className={styles.title}>
        <span className={clsx(styles.title, styles.titleThin)}>Completed</span> projects
      </p>
    </FadeIn>
    <FadeIn delay={0.4}>
      <p className={styles.subTitle}>
        We've empowered over 50 fintechs and banks to help their customers
        <br />
        travel the world with freedom through our travel solution
      </p>
    </FadeIn>
    <FadeIn delay={0.6} className={styles.numbersContainer}>
      {CompletedProjectsData.map((item) => (
        <React.Fragment key={item.id}>
          <hr className={styles.line} />
          <div className={styles.numberBlock}>
            <p className={styles.number}>{item.number}</p>
            <p className={styles.text}>{item.text}</p>
          </div>
        </React.Fragment>
      ))}
    </FadeIn>
  </section>
);

export default CompletedProjects;
